import { Box, Grid, Typography } from '@mui/material';
import { Supply } from '../../apiTypes';
import PrintModal from '../../components/PrintModal';
import { t } from '../../constants/translations';
import { useCafe } from '../../contexts/cafe.context';
import { useLocale } from '../../contexts/locale.context';
import getQntLabel from '../../utils/getQntLabel';

interface Props {
  onClose: () => void;
  supply?: DbDocument<Supply> | null;
}

const SupplyPrintModal = (props: Props) => {
  const { onClose, supply } = props;
  const { ingredientsMap } = useCafe();
  const { lang } = useLocale();

  return (
    <PrintModal onClose={onClose}>
      <Typography variant="h6" sx={{ mt: 2 }}>{`${t.supply[lang]} #${supply?.number}`}</Typography>
      {supply?.provider && (
        <Typography variant="subtitle1" sx={{ mb: 2 }}>{`${t.provider[lang]}: ${supply?.provider}`}</Typography>
      )}
      <Box p={2}>
        {supply?.components.map((c) => {
          const ingredient = ingredientsMap[c.id];

          if (!ingredient) {
            return null;
          }

          return (
            <Grid key={c.id} container spacing={2} sx={{ borderBottom: `1px solid #555`, mt: 1 }}>
              <Grid item xs={1}>
                <Box sx={{ width: 12, height: 12, border: `2px solid #555` }} />
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ lineHeight: 0.8 }}>{ingredient.name}</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>{getQntLabel(c.qnt, ingredient, lang)}</Typography>
              </Grid>
            </Grid>
          );
        })}
      </Box>
    </PrintModal>
  );
};

export default SupplyPrintModal;
